import VueRouter from 'vue-router/dist/vue-router.esm';
import config from "./Config";
import Base64 from '../libs/base64';
import Vue from 'vue/dist/vue.runtime.esm';
import home from "./view/home";
// import routelib from './router_lib';
/**
 * 将route层级转化为单个层级
 * @param routes
 * @param parentRoute
 * @param rootRoutes
 * @param hash
 * @returns {*}
 */
function initRoutes(routes, parentRoute, rootRoutes, hash) {
    for (let i of routes) {
        if (parentRoute) {
            i.meta = i.meta || {};
            i.meta.parent = parentRoute;
            if (i.path[0] == '/') {
                i.path = parentRoute.path + i.path;
            } else {
                i.path = parentRoute.path + '/' + i.path;
            }
        }
        hash[i.path] = i;
        rootRoutes.push(i);
        if (i.children && i.children.length) {
            initRoutes(i.children, i, rootRoutes, hash);
            delete i.children;
        }
    }
    return rootRoutes;
}

Vue.use(VueRouter);
const RoutesHash = {};
const Routes = [
    {
        path: '/',
        name: 'index',
    },
    {
        path: '/home',
        name: 'home',
        component: home,
    },
];
const VueRoutes = new VueRouter({
    routes: initRoutes(Routes, null, [], RoutesHash),
    // routes: Routes,
    routesHash: RoutesHash,
});
VueRoutes.afterEach((to, from) => {
    let rParam=sessionStorage.getItem(config.APPID+'_rParam'),rName=to.name
    if(rParam)rParam=JSON.parse(Base64.decode(rParam.slice(5))+'')
    else rParam={}
    if(Object.keys(to.params).length>0){
        rParam[rName]=to.params
        sessionStorage.setItem(config.APPID+'_rParam',Base64.encode(Date.now().toString()).slice(-7,-2)+Base64.encode(JSON.stringify(rParam)))
    }else {
        rParam=rParam[rName]
        if(rParam&&Object.keys(rParam).length>0){
            Object.keys(rParam).map(k=>{
                to.params[k]=rParam[k]
            })
        }
    }
})
//处理面包屑的数据
// VueRoutes.afterEach(routelib.afterEach);
// VueRoutes.beforeResolve(routelib.beforeResolve);
export default VueRoutes;
